export default __webpack_public_path__ + "static/media/clinic-card.2957937d.png";